import styled from 'styled-components';

import {
  Sidebar as SemanticSidebar,
} from 'semantic-ui-react';

import { colors } from '@playbookux/playbook-web-core';

const { SIDEBAR_COLOR, SIDEBAR_SELECTED_COLOR } = colors;

const Container = styled(SemanticSidebar)`
  &&& {
    margin-top: 55px !important;
  }
  height: 100%;
  width: 250px !important;
  direction: left;
  align-items: center;
  background-color: ${SIDEBAR_COLOR};
  letter-spacing: 0.65px;
`;

// Item.
const Items = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 60px;
  &&& :hover {
    cursor: pointer;
    background-color: ${SIDEBAR_SELECTED_COLOR};
  }
`;

export {
  Container,
  Items,
};
